import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../../components/common/SpinnerComponentUI'
import AccountPropertyUpdateModalSF from './AccountPropertyUpdateModalSF'
// import './AccountPropertyList.css'

const AccountPropertyListUI = ({context, propertyList, errorList, account,
    // modes
    updateMode, selectedProperty, category, categoryLabel,
    // event handlers
    onRefreshClick, onUpdateClick, onCancelClick, onUpdate
  }) =>
  <CardUI className='su_l_props g_m_top_100' title={categoryLabel} noUnderline={true}>
    <LRTableBodyUI>
      {
        propertyList && propertyList.filter(p => p.category === category).map((property, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} property={property} />}
            right={<RowRightUI property={property} onUpdateClick={onUpdateClick} />}
          />
        )
      }
    </LRTableBodyUI>

    <AccountPropertyUpdateModalSF
      context={context}
      errorList={errorList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedProperty={selectedProperty}
      onUpdate={onUpdate}
      account={account}
    />
  </CardUI>

  const RowLeftUI = ({context, i, property}) =>
    <div className='g_flex_v g_flex_left'>
      <span>{property.propertyName}</span>
      {
        property.hint &&
        <span className='g_muted g_small'>{property.hint}</span>
      }
    </div>

  const RowRightUI = ({property, onUpdateClick}) =>
    <div className='g_flex_h g_m_left_100 g_flex_top g_flex_right'>
      {
        property.propertyType !== 'boolean_' &&
        <span className='wrap'>{property.propertyValue || property.defaultValue}</span>
      }
      {
        property.propertyType === 'boolean_' &&
        <span>{property.propertyValue != null ? (property.propertyValue === '1' ? 'Yes' : 'No') :
           (property.defaultValue === '1' ? 'Yes' : 'No')}</span>
      }
      <span className='icon icon-pencil g_link_2 g_m_left_50'
        data-property={property.propertyCode} onClick={onUpdateClick} />
    </div>


export default AccountPropertyListUI
